/**
 * Khung an toàn cho phần custom của từng khách: lỗi bên trong chỉ làm hỏng đúng khung đó,
 * phần còn lại của trang (lõi) vẫn chạy.
 */
import { Component, type ReactNode } from 'react'

export class KhungAnToan extends Component<{ children: ReactNode; ten?: string }, { loi: Error | null }> {
  state = { loi: null as Error | null }
  static getDerivedStateFromError(loi: Error) { return { loi } }
  componentDidCatch(loi: Error) { console.error(`[custom] ${this.props.ten ?? 'khung'} lỗi:`, loi) }
  render() {
    if (this.state.loi) {
      return (
        <div className="m-3 rounded-md border border-destructive/30 bg-destructive/5 p-3 text-sm text-destructive">
          Phần “{this.props.ten ?? 'tuỳ chỉnh'}” đang gặp lỗi — các chức năng khác vẫn dùng bình thường.
        </div>
      )
    }
    return this.props.children
  }
}
